import {Box} from "@mui/material";
import React from "react";

export function CameraIcon(props) {
    return(
        <img src="/Icons/camera.svg" alt="camera" {...props}/>
    )
}